import { bool, func, number, objectOf, string } from 'prop-types';
import React from 'react';
import Icon from 'yoda-core-components/lib/components/Icon';
import VideoNew from 'yoda-core-components/lib/assets/svg/VideoNew.svg';
import classNames from 'classnames/bind';
import VideoPlayer from '../../../VideoPlayer/VideoPlayer';
import * as styles from './ProductVideo.css';

const cx = classNames.bind(styles);

const ProductVideo = (props) => {
    const {
        deviceType: { isDesktop },
        galleryProductCard,
        index,
        playVideo,
        renderVideo,
        setParentState,
        triggerAnalytics,
        videoId,
    } = props;

    const buttonClasses = ['absolute', 'block', cx('play-button')].join(' ');
    const dataAutomationId = galleryProductCard ? `gallery-video-${videoId}` : '';
    const iconSize = !__SERVER__ && window.innerWidth >= 1440 ? '38' : '32';
    const pageId = galleryProductCard ? 'galleryVideo' : '';
    const videoWrapper = cx('absolute', 'h-full', 'video-wrapper', 'w-full');

    const startVideo = () => {
        setParentState({
            playVideo: true,
        });
    };

    const stopVideo = () => {
        setParentState({
            playVideo: false,
        });
    };

    const renderPlayer = () => {
        return renderVideo ? (
            <div className={videoWrapper}>
                <VideoPlayer
                    automationId={dataAutomationId}
                    index={index}
                    onEnd={stopVideo}
                    pageId={pageId}
                    triggerAnalytics={triggerAnalytics}
                    videoId={videoId}
                />
            </div>
        ) : null;
    };

    const renderButton = () => {
        return (
            <div className={buttonClasses} data-automation-id="product-video">
                <button onClick={() => startVideo()} type="button">
                    <Icon
                        automationId="video-automation-product"
                        height={iconSize}
                        width={iconSize}
                    >
                        <VideoNew />
                    </Icon>
                </button>
            </div>
        );
    };

    if (isDesktop && videoId) {
        return playVideo ? renderPlayer() : renderButton();
    }
    return null;
};

ProductVideo.propTypes = {
    setParentState: func.isRequired,
    deviceType: objectOf(bool),
    galleryProductCard: bool,
    index: number,
    playVideo: bool,
    renderVideo: bool,
    triggerAnalytics: func,
    videoId: string,
};

ProductVideo.defaultProps = {
    deviceType: {},
    galleryProductCard: false,
    index: 0,
    playVideo: false,
    renderVideo: false,
    triggerAnalytics: null,
    videoId: '',
};

export default ProductVideo;
